import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "mb-6" }
const _hoisted_2 = { class: "rounded-[20px] overflow-y-auto" }
const _hoisted_3 = { class: "bg-brown text-white text-sm leading-[16px] lg:text-xl lg:leading-[24px]" }
const _hoisted_4 = { class: "font-normal lg:font-semibold pl-2 pr-1 lg:px-4 py-6 w-[200px]" }
const _hoisted_5 = { class: "th-item" }
const _hoisted_6 = { class: "th-item" }
const _hoisted_7 = { class: "th-item" }
const _hoisted_8 = { class: "font-normal lg:font-semibold pr-2 pl-1 lg:px-4 py-6" }
const _hoisted_9 = {
  key: 0,
  class: "font-normal lg:font-semibold pr-2 pl-1 lg:px-4 py-6"
}
const _hoisted_10 = { class: "font-normal lg:font-semibold pr-2 pl-1 lg:px-4 py-6" }
const _hoisted_11 = { class: "bg-white" }
const _hoisted_12 = { class: "pl-2 pr-1 lg:px-4 py-2" }
const _hoisted_13 = { class: "flex gap-2 items-center" }
const _hoisted_14 = { class: "w-min" }
const _hoisted_15 = { class: "max-w-96 text-left" }
const _hoisted_16 = { class: "td-item" }
const _hoisted_17 = { class: "td-item" }
const _hoisted_18 = { class: "td-item" }
const _hoisted_19 = { class: "pl-1 pr-2 lg:px-4 py-2" }
const _hoisted_20 = { class: "flex flex-col" }
const _hoisted_21 = { class: "w-min" }
const _hoisted_22 = { class: "max-w-96 text-left" }
const _hoisted_23 = {
  key: 0,
  class: "pl-1 pr-2 lg:px-4 py-2"
}
const _hoisted_24 = { class: "td-item" }

import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import { ActivationItemGroup } from "@/types/calculators";
import InfoIcon from "@/components/icons/InfoIcon.vue";
import AppTooltip from "@/components/AppTooltip.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ActivationResults',
  props: {
    resultedActivations: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();

const tableRef = ref<HTMLElement>();

const hasFavourableForColumn = computed(() => {
  for (const resultedActivation of props.resultedActivations) {
    if (resultedActivation.especially_favorable_for !== null) {
      return true;
    }
  }
  return false;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", {
        class: "w-full text-left overflow-hidden",
        ref_key: "tableRef",
        ref: tableRef
      }, [
        _createElementVNode("thead", _hoisted_3, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", _hoisted_4, _toDisplayString(_unref(t)("calculators.activations.results.name")), 1),
            _createElementVNode("th", _hoisted_5, _toDisplayString(_unref(t)("calculators.activations.results.date")), 1),
            _createElementVNode("th", _hoisted_6, _toDisplayString(_unref(t)("calculators.activations.results.time")), 1),
            _createElementVNode("th", _hoisted_7, _toDisplayString(_unref(t)("calculators.activations.results.sector")), 1),
            _createElementVNode("th", _hoisted_8, _toDisplayString(_unref(t)("calculators.activations.results.activators")), 1),
            (hasFavourableForColumn.value)
              ? (_openBlock(), _createElementBlock("th", _hoisted_9, _toDisplayString(_unref(t)("calculators.activations.results.especially_favorable_for")), 1))
              : _createCommentVNode("", true),
            _createElementVNode("th", _hoisted_10, _toDisplayString(_unref(t)("calculators.activations.results.not_suitable_for")), 1)
          ])
        ]),
        _createElementVNode("tbody", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.resultedActivations, (activation, i) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: i,
              class: "border-t font-normal text-sm leading-[16px] lg:text-base lg:leading-[20px] text-black"
            }, [
              _createElementVNode("td", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(t)(
                      `calculators.activations.activation_list.${activation.activation_name}`
                    )), 1),
                  _createVNode(AppTooltip, {
                    containerRef: tableRef.value,
                    class: "no-print flex-shrink-0"
                  }, {
                    trigger: _withCtx(() => [
                      _createVNode(InfoIcon, { class: "size-6 text-active" })
                    ]),
                    popper: _withCtx(() => [
                      _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(t)(
                          `calculators.activations.activation_description.${activation.activation_name}`
                        )), 1)
                    ]),
                    _: 2
                  }, 1032, ["containerRef"])
                ])
              ]),
              _createElementVNode("td", _hoisted_16, _toDisplayString(activation.date), 1),
              _createElementVNode("td", _hoisted_17, [
                _createElementVNode("div", null, _toDisplayString(activation.hour_symbol), 1),
                _createElementVNode("div", null, _toDisplayString(activation.time_interval), 1)
              ]),
              _createElementVNode("td", _hoisted_18, [
                (Array.isArray(activation.activation_sector))
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(activation.activation_sector, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "flex flex-col"
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_unref(t)(`faq.sectors.mountains.${item.sector}`)), 1)
                      ]))
                    }), 128))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_unref(t)(`faq.sectors.mountains.${activation.activation_sector}`)), 1)
                    ], 64))
              ]),
              _createElementVNode("td", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activation.activators, (activator, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "flex gap-2 items-center",
                      key: idx
                    }, [
                      _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(t)(`calculators.activations.activators.${activator}`)), 1),
                      _createVNode(AppTooltip, {
                        containerRef: tableRef.value,
                        class: "no-print flex-shrink-0"
                      }, {
                        trigger: _withCtx(() => [
                          _createVNode(InfoIcon, { class: "size-6 text-active" })
                        ]),
                        popper: _withCtx(() => [
                          _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(t)(
                            `calculators.activations.faq.activators.${activator}`
                          )), 1)
                        ]),
                        _: 2
                      }, 1032, ["containerRef"])
                    ]))
                  }), 128))
                ])
              ]),
              (hasFavourableForColumn.value)
                ? (_openBlock(), _createElementBlock("td", _hoisted_23, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activation.especially_favorable_for, (favourableFor, idx) => {
                      return (_openBlock(), _createElementBlock("div", { key: idx }, _toDisplayString(favourableFor), 1))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("td", _hoisted_24, _toDisplayString(activation.not_suitable_for), 1)
            ]))
          }), 128))
        ])
      ], 512)
    ])
  ]))
}
}

})